<app-landing-page
	id="landing-page-container-component"
	[bundle]="resourceBundle.bundle | async"
	[guestsCompleted]="guestsCompleted$ | async"
	[guestsNotCompleted]="guestsNotCompleted$ | async"
	[language]="language$ | async"
	[loggedInGuest]="loggedInGuest$ | async"
	[selectedGuests]="selectedGuests$ | async"
	[isAnyGuestLocked]="isAnyGuestLocked"
	[arrivalTimeAlert]="arrivalTimeAlert"
	[session]="session$ | async"
	[screensize]="screensize$ | async"
	[checkInEntryInterrupt]="checkInEntryInterrupt$ | async"
	[checkInGuestSelectBanner]="checkInGuestSelectBanner | async"
>
</app-landing-page>
